import { render, staticRenderFns } from "./navigation-main-button.vue?vue&type=template&id=f0ceb4a4&scoped=true"
import script from "./navigation-main-button.vue?vue&type=script&lang=ts"
export * from "./navigation-main-button.vue?vue&type=script&lang=ts"
import style0 from "./navigation-main-button.vue?vue&type=style&index=0&id=f0ceb4a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ceb4a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
